/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Address from './Address/index'
import CancelAction from './CancelAction/index'
import Details from './Details/index'
import EditOrAdd from './EditOrAdd/index'
import Email from './Email/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import Notes from './Notes/index'
import Phone from './Phone/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import UpdateAction from './UpdateAction/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content",
  onClose
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 onClose={onClose}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Edit Professional"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
 onClick={onClose}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<React.Fragment>
<Details
{...childProps}
  viewPath={`${viewPath}/Details`}
/>
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={dtSpaceS}
 level="h4"
 color={dtColorsNeutral800}
 text="Contact Information"
/>
<Phone
{...childProps}
  viewPath={`${viewPath}/Phone`}
/>
<HorizontalDivider
{...childProps}
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Email
{...childProps}
  viewPath={`${viewPath}/Email`}
/>
<HorizontalDivider
{...childProps}
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Address
{...childProps}
  viewPath={`${viewPath}/Address`}
/>
<Notes
{...childProps}
  viewPath={`${viewPath}/Notes`}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
 onClick={onClose}
/>
<UpdateAction
{...childProps}
  viewPath={`${viewPath}/UpdateAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
<EditOrAdd
  viewPath={`${viewPath}/EditOrAdd`}
/>
{children}
</React.Fragment>)
}